import { memo } from 'react';
import CsvDownloadButton from 'react-json-to-csv';

import styles from './styles.module.scss';

function CsvDownload({ className, template, fileName }) {
  return (
    <div className={className}>
      Download
      <CsvDownloadButton className={styles['csv-button']} data={template} filename={fileName}>
        example
      </CsvDownloadButton>
      CSV file.
    </div>
  );
}

export default memo(CsvDownload);
